import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';
import type { CostResponse } from '../api/contracts';

export * from './costTransforms';

/**
 * GET /api/cost?from=&to= — energy cost modeled against the tariff rows in
 * effect for the range. See api/src/lib/tariff.ts's header comment
 * (conventions 4 and 7) for why `fixedCents`/`percentCents` only ever appear
 * at the month/total level and never inside `byHour`: a flat monthly fee or
 * bill-level percentage rider can't be attributed to a single hour's kWh
 * without distorting that hour's real marginal cost. The dollar-conversion
 * helpers this hook's consumers use (`toCostSummaryDollars`, `toMonthRows`,
 * `toHourlyEnergyPoints`) live in ./costTransforms.ts and respect that split.
 */
export function useCost(from: string, to: string) {
  return useQuery({
    queryKey: ['cost', from, to],
    queryFn: () => apiClient.get<CostResponse>(`/api/cost?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`),
    enabled: Boolean(from && to),
  });
}
